import { AI_CHATBOT_ACTIONS, type AllChatbotActions } from "../actions/actions";
import type { ChatbotState } from "../types/chatbot.reducer.type";

export function subscribtionReducer(state: ChatbotState, action: AllChatbotActions) {
  switch (action.type) {
    case AI_CHATBOT_ACTIONS.SET_USER_SUBSCRIPTION_TIER:
      return {
        ...state,
        userSubscriptionTier: action.payload.userSubscriptionTier,
      };
    case AI_CHATBOT_ACTIONS.SET_REQUIRED_TIER_FOR_CHATBOT:
      return {
        ...state,
        requiredTierForChatbot: action.payload.requiredTierForChatbot,
      };
    default:
      return {};
  }
}
